const memberAsset = (name) => `${process.env.PUBLIC_URL}/sbhrp/lab-members/${name}`;

const sbhrpLabMembers = {
  ar: {
    pageTitle: 'أعضاء مختبر الابتكار — الحفل الختامي',
    pageIntro: 'المشاركون في مختبر الابتكار ضمن مشروع SBHRP، كما وردوا في الحفل الختامي.',
    projectLabel: 'اسم المشروع',
    backLabel: 'العودة إلى صفحة المشروع',
    membersButton: 'أعضاء مختبر الابتكار — الحفل الختامي',
    members: [
      {
        id: 1,
        project: "بيت الخشب الفلسطيني",
        name: "زينب سماره",
        image: memberAsset('member-01.png'),
      },
      {
        id: 2,
        project: "مركز شيرين للتدريب",
        name: "شيرين دلال",
        image: memberAsset('member-02.png'),
      },
      {
        id: 3,
        project: "غرزة شيرين",
        name: "شيرين خريم",
        image: memberAsset('member-03.jpeg'),
      },
      {
        id: 4,
        project: "Macrame Fashion",
        name: "ولاء سليم",
        image: memberAsset('member-04.png'),
      },
      {
        id: 5,
        project: "مزرعة الأخوة",
        name: "آية مليطات",
        image: memberAsset('member-05.jpeg'),
      },
      {
        id: 6,
        project: "Paltatreez",
        name: "نداء نصار",
        image: memberAsset('member-06.jpeg'),
      },
      {
        id: 7,
        project: "pal microgreens",
        name: "رابية غنايم",
        image: memberAsset('member-07.jpeg'),
      },
      {
        id: 8,
        project: "Grand Sweets",
        name: "غدير فحماوي",
        image: memberAsset('member-08.jpeg'),
      },
      {
        id: 9,
        project: "منتوجات الشيف الفلسطيني",
        name: "حنان عماش",
        image: memberAsset('member-09.jpeg'),
      },
      {
        id: 10,
        project: "مطبخ بصمة المجتمعي",
        name: "تامر يونس",
        image: memberAsset('member-10.jpeg'),
      },
      {
        id: 11,
        project: "مطبخ على كيفك",
        name: "حكمت غيث",
        image: null,
      },
      {
        id: 12,
        project: "مزرعة الخير النموذجية",
        name: "معتصم دعنه",
        image: null,
      },
      {
        id: 13,
        project: "صابون زيت الزيتون",
        name: "آية بيقاوي",
        image: null,
      },
      {
        id: 14,
        project: "حبكتنا حكايتنا",
        name: "جهاد الرطروط",
        image: null,
      },
      {
        id: 15,
        project: "متجر أشياء وهدايا",
        name: "ربا أبو حسين",
        image: memberAsset('member-15.jpeg'),
      },
      {
        id: 16,
        project: "لمسة فنية",
        name: "مريم دراغمه",
        image: null,
      },
      {
        id: 17,
        project: "يارا لاتيه",
        name: "يارا عيسى",
        image: memberAsset('member-17.png'),
      },
      {
        id: 18,
        project: "مكتب الأسيل للتصميم الداخلي والديكور",
        name: "أسيد شلبي",
        image: memberAsset('member-18.png'),
      },
      {
        id: 19,
        project: "Julia candles",
        name: "أسيل أبو دغش",
        image: null,
      },
      {
        id: 20,
        project: "حلويات الشعله",
        name: "أسيل أبو شعله",
        image: null,
      },
      {
        id: 21,
        project: "مناحل عسل الأرض المباركة",
        name: "باكزة شواهنة",
        image: memberAsset('member-21.png'),
      },
      {
        id: 22,
        project: "Gomana إيكو كلين",
        name: "جمانة أبو غليون",
        image: null,
      },
      {
        id: 23,
        project: "ثوبي للمطرزات التراثيه",
        name: "حسنه حوامده",
        image: null,
      },
      {
        id: 24,
        project: "صناعة كريمات وزيوت وصوابين  طبيعية وعطور",
        name: "حنان فحماوي",
        image: null,
      },
      {
        id: 25,
        project: "مركز إبداع التعليمي",
        name: "راما سماره",
        image: null,
      },
      {
        id: 26,
        project: "razansweet&flowers",
        name: "رزان الهور",
        image: null,
      },
      {
        id: 27,
        project: "تصنيع البان وأجبان",
        name: "رنا بوزيه",
        image: memberAsset('member-27.jpeg'),
      },
      {
        id: 28,
        project: "دار عبير للتراث",
        name: "عبير بريجيه",
        image: null,
      },
      {
        id: 29,
        project: "مطبخ منزلي",
        name: "غدير صوافطه",
        image: null,
      },
      {
        id: 30,
        project: "مركز حرف وحروف الابداعي",
        name: "فاتن يوسف",
        image: null,
      },
      {
        id: 31,
        project: "Vanilla",
        name: "لما نمر",
        image: memberAsset('member-31.jpeg'),
      },
      {
        id: 32,
        project: "Softness care",
        name: "مرام ازحيمان",
        image: null,
      },
      {
        id: 33,
        project: "متجر تحفة",
        name: "نور درويش",
        image: null,
      },
      {
        id: 34,
        project: "أحفاد الجزري",
        name: "هاجر أبو رميلة",
        image: null,
      },
      {
        id: 35,
        project: "هوية وطن",
        name: "ولاء بريغيث",
        image: memberAsset('member-35.jpeg'),
      },
    ],
  },
  en: {
    pageTitle: 'Innovation Lab Members — Closing Ceremony',
    pageIntro: 'Participants in the SBHRP Innovation Lab as presented at the closing ceremony.',
    projectLabel: 'Project name',
    backLabel: 'Back to project page',
    membersButton: 'Innovation Lab Members — Closing Ceremony',
    members: [
      {
        id: 1,
        project: "بيت الخشب الفلسطيني",
        name: "زينب سماره",
        image: memberAsset('member-01.png'),
      },
      {
        id: 2,
        project: "مركز شيرين للتدريب",
        name: "شيرين دلال",
        image: memberAsset('member-02.png'),
      },
      {
        id: 3,
        project: "غرزة شيرين",
        name: "شيرين خريم",
        image: memberAsset('member-03.jpeg'),
      },
      {
        id: 4,
        project: "Macrame Fashion",
        name: "ولاء سليم",
        image: memberAsset('member-04.png'),
      },
      {
        id: 5,
        project: "مزرعة الأخوة",
        name: "آية مليطات",
        image: memberAsset('member-05.jpeg'),
      },
      {
        id: 6,
        project: "Paltatreez",
        name: "نداء نصار",
        image: memberAsset('member-06.jpeg'),
      },
      {
        id: 7,
        project: "pal microgreens",
        name: "رابية غنايم",
        image: memberAsset('member-07.jpeg'),
      },
      {
        id: 8,
        project: "Grand Sweets",
        name: "غدير فحماوي",
        image: memberAsset('member-08.jpeg'),
      },
      {
        id: 9,
        project: "منتوجات الشيف الفلسطيني",
        name: "حنان عماش",
        image: memberAsset('member-09.jpeg'),
      },
      {
        id: 10,
        project: "مطبخ بصمة المجتمعي",
        name: "تامر يونس",
        image: memberAsset('member-10.jpeg'),
      },
      {
        id: 11,
        project: "مطبخ على كيفك",
        name: "حكمت غيث",
        image: null,
      },
      {
        id: 12,
        project: "مزرعة الخير النموذجية",
        name: "معتصم دعنه",
        image: null,
      },
      {
        id: 13,
        project: "صابون زيت الزيتون",
        name: "آية بيقاوي",
        image: null,
      },
      {
        id: 14,
        project: "حبكتنا حكايتنا",
        name: "جهاد الرطروط",
        image: null,
      },
      {
        id: 15,
        project: "متجر أشياء وهدايا",
        name: "ربا أبو حسين",
        image: memberAsset('member-15.jpeg'),
      },
      {
        id: 16,
        project: "لمسة فنية",
        name: "مريم دراغمه",
        image: null,
      },
      {
        id: 17,
        project: "يارا لاتيه",
        name: "يارا عيسى",
        image: memberAsset('member-17.png'),
      },
      {
        id: 18,
        project: "مكتب الأسيل للتصميم الداخلي والديكور",
        name: "أسيد شلبي",
        image: memberAsset('member-18.png'),
      },
      {
        id: 19,
        project: "Julia candles",
        name: "أسيل أبو دغش",
        image: null,
      },
      {
        id: 20,
        project: "حلويات الشعله",
        name: "أسيل أبو شعله",
        image: null,
      },
      {
        id: 21,
        project: "مناحل عسل الأرض المباركة",
        name: "باكزة شواهنة",
        image: memberAsset('member-21.png'),
      },
      {
        id: 22,
        project: "Gomana إيكو كلين",
        name: "جمانة أبو غليون",
        image: null,
      },
      {
        id: 23,
        project: "ثوبي للمطرزات التراثيه",
        name: "حسنه حوامده",
        image: null,
      },
      {
        id: 24,
        project: "صناعة كريمات وزيوت وصوابين  طبيعية وعطور",
        name: "حنان فحماوي",
        image: null,
      },
      {
        id: 25,
        project: "مركز إبداع التعليمي",
        name: "راما سماره",
        image: null,
      },
      {
        id: 26,
        project: "razansweet&flowers",
        name: "رزان الهور",
        image: null,
      },
      {
        id: 27,
        project: "تصنيع البان وأجبان",
        name: "رنا بوزيه",
        image: memberAsset('member-27.jpeg'),
      },
      {
        id: 28,
        project: "دار عبير للتراث",
        name: "عبير بريجيه",
        image: null,
      },
      {
        id: 29,
        project: "مطبخ منزلي",
        name: "غدير صوافطه",
        image: null,
      },
      {
        id: 30,
        project: "مركز حرف وحروف الابداعي",
        name: "فاتن يوسف",
        image: null,
      },
      {
        id: 31,
        project: "Vanilla",
        name: "لما نمر",
        image: memberAsset('member-31.jpeg'),
      },
      {
        id: 32,
        project: "Softness care",
        name: "مرام ازحيمان",
        image: null,
      },
      {
        id: 33,
        project: "متجر تحفة",
        name: "نور درويش",
        image: null,
      },
      {
        id: 34,
        project: "أحفاد الجزري",
        name: "هاجر أبو رميلة",
        image: null,
      },
      {
        id: 35,
        project: "هوية وطن",
        name: "ولاء بريغيث",
        image: memberAsset('member-35.jpeg'),
      },
    ],
  },
};

export default sbhrpLabMembers;
